import Empty from './Empty'
import UploadPictures from './UploadPictures'
import Ueditor from './Ueditor'
import Loading from './Loading'
import FloatButton1 from './FloatButton1'
import Notice from './Notice'

export default {
    install(Vue, options) {
        Vue.component('Empty', Empty)
        Vue.component('UploadPictures', UploadPictures)
        Vue.component('Ueditor', Ueditor)
        Vue.component('Loading', Loading)
        Vue.component('FloatButton1', FloatButton1)
        Vue.component('Notice', Notice)
　　}
}     